import keyMirror from "keymirror";
export const ActionTypes = keyMirror({
  API_FAIL: null,

  createProject: null,
  deleteProject: null,
  updateProject: null,
  updateProjectField: null,
  getProjects: null,
  getProject: null,
  updateProjectState: null,
  changeAppState: null,

  getBuckets: null,
  saveBucket: null,
  setUpBuckets: null,
  deleteBucket: null,
  changeBucketOrder: null,

  getLabels: null,
  saveLabel: null,
  deleteLabel: null,
  updateLabel: null,

  getMyFilters: null,
  updateMyFilterSettings: null,
  saveFilter: null,
  deleteFilter: null,

  getFields: null,
  getFavoriteTree: null,
  updateFavoriteTree: null,
  getFormSetting: null,
  updateFormSetting: null,
  getWorkspaceAutomationUsage: null,

  // User
  getUsers: null,
  getUser: null,
  loginWithJwt: null,
  updateCurrentUserSetting: null,
  updateCurrentUserFilters: null,
  getCurrentUser: null,
  setCurrentUser: null,
  setCurrentUserJWT: null,
  searchItems: null,

  // Activities
  searchActivities: null,
  countMyDueOverActivities: null,

  // Items
  getItem: null,
  updateTask: null,
  resetTask: null,
  updateTaskData: null,
  selectItem: null,
  selectAllItems: null,
  bulkDeleteItems: null,

  changeFilters: null,
  changeSorts: null,
  changeGroupBy: null,
  changeBoardCardFields: null,
  changeGridFields: null,
  changeShowCardLabels: null,

  changeViewModeData: null,
  showViewModeDialog: null,
  hideViewModeDialog: null,

  changeFilterString: null,
  showTaskDialog: null,
  hideTaskDialog: null,
  showRightPanelDialog: null,
  hideRightPanelDialog: null,
  updateTaskDialog: null,
  resetTaskDialog: null,

  // Item Link
  getItemLink: null,

  // Item scoring
  getEstimatedProbability: null,
  getConnectionStrength: null,

  // Messages
  selectInboxApp: null,
  searchMessages: null,
  getMessageThread: null,
  showMessageView: null,
  hideMessageView: null,

  createActivity: null,
  showActivityDialog: null,
  changeActivityData: null,
  hideActivityDialog: null,
  resetActivityDialog: null,
  // chrome
  changeFiltersUpcomingChrome: null,
  searchUpcomingChrome: null,
  showActivityDialogChrome: null,
  hideActivityDialogChrome: null,

  changeEmailData: null,
  showEmailDialog: null,
  hideEmailDialog: null,

  // Grid view
  changeColumnOrder: null,
  showHideColumn: null,
  setColumn: null,
  setColumnAggregatingFunc: null,
  showGridDialog: null,
  setNewTaskId: null,

  // Chart view
  getDashboards: null,
  saveDashboard: null,
  addWidget: null,

  // Reports
  getReport: null,
  getReports: null,
  saveReport: null,
  deleteReport: null,

  settingActiveTabReport: null,
  settingDataReport: null,
  resetSettingDataReport: null,
  settingTableReport: null,

  // layout
  showAppNav: null,
  setNotification: null,
  clearNotification: null,
  countUnreadNotification: null,
  hoverDataItem: null,

  // Rule
  getRules: null,
  getAppLinks: null,
  setDefaultPageApp: null,
  getRule: null,
  saveRule: null,
  deleteRule: null,
  enableRule: null,
  setCurrentRule: null,
  setPlatformProfile: null,
  // Rule logs (activity / run history)
  getRuleLogs: null,
  getRuleLogDetail: null,
  getRuleMetrics: null,
  setRuleLogDetail: null,
  clearRuleLogs: null,

  // Goal
  getGoals: null,
  getGoal: null,
  resetGoalForm: null,
  saveGoal: null,
  deleteGoal: null,
  enableGoal: null,
  setCurrentGoal: null,

  // Template
  getTemplates: null,
  getAttributes: null,

  // Admin
  getMembers: null,
  activeMember: null,
  enableAdmin: null,
  removeMember: null,

  // Info
  getBuildInfo: null,
  getTeamMembers: null,
  activeTeamMember: null,
  enableAdminTeamMember: null,
  removeTeamMember: null,
  getTeamPipelines: null,

  // Contact
  getContactInfoByIssue: null,

  // Admin
  getTenants: null,
  setTenantBillingPayload: null,

  // AI Content
  generateContents: null,
  saveAIContentSetting: null,
  updateAIContentSetting: null,

  updateSocialPosts: null,
  updatePostDetail: null,
  setSocialPosts: null,
  showPostDetailDialog: null,
  hidePostDetailDialog: null,
  updateSharePost: null,
  showSharePostDialog: null,
  hideSharePostDialog: null,
  getCanvaDesigns: null,
  getFileImages: null,
  clearSocialPosts: null,
  setPlatformFilter: null,
  setStatusFilter: null,
  setTimezoneFilter: null,
  setTimezone: null,
  resetAIContentState: null,
  clearAiSettingsChangedSinceLastGenerate: null,
  scheduleBatch: null,
  searchSocialPosts: null,
  refreshCalendarData: null,
  setCurrentDate: null,

  // TopicsModal
  openTopicsModal: null,
  closeTopicsModal: null,
  selectTopic: null,
  deselectTopic: null,
  selectAllTopics: null,
  deselectAllTopics: null,
  confirmTopicSelection: null,
  setGenerateModalLoading: null,
  closeGenerateModal: null,

  // Billing
  getBillingTokenUsage: null,
  getBillingUserLimits: null,
  getBillingSubscriptionStatus: null,
  getBillingPlans: null,
  getBillingPaymentMethod: null,
  setCheckoutSession: null,
  showSelectPlanDialog: null,
  hideSelectPlanDialog: null,
  showUpgradePlanDialog: null,
  hideUpgradePlanDialog: null,
});

export const DialogTypes = keyMirror({
  mainDialog: null,
  sideDialog: null,
  sideMyInboxDialog: null,
  sideMyInboxMessageDialog: null,
  sideBulkEditDialog: null,
  activityDialog: null,
  mapEventDialog: null,
  createCustomFieldDialog: null,
  updateCustomFieldDialog: null,
  confirmDialog: null,
  confirmBucketDialog: null,
});

export const ActivityTypes = keyMirror({
  meeting: null,
  task: null,
  call: null,
  deadline: null,
  email: null,
  logEmail: null,
  sendEmail: null,
  lunch: null,
  commented: null,
  comment: null,
  file: null,
  price: null,
  variation: null,
  sendDraftEmail: null,
  sendScheduledEmail: null,
  recordSentEmail: null,
});

export const ContentTypes = keyMirror({
  TASK: null,
  ISSUE: null,
  ACTIVITY: null,
  SALE: null,
  CONTACT: null,
  COMPANY: null,
  PRODUCT: null,
  WORK_LOG: null,
  EXPENSE: null,
  EVENT_MAP: null,
  TRACKING: null,
});

export const TemplateContexts = keyMirror({
  SALE: null,
  CONTACT: null,
  COMPANY: null,
  PRODUCT: null,
  ACTIVITY: null,
  SENDER: null,
  RECIPIENT: null,
});

export const RuleOperators = keyMirror({
  UPDATED_FIELD: null,
  SEND_TO_SLACK_CHANNEL: null,
  SEND_EMAIL: null,
  MAILCHIMP_SYNC_EMAILS: null,
  SET_FIELD: null,
  AI_FIELD: null,
  NEW_SALE: null,
  NEW_CONTACT: null,
  NEW_COMPANY: null,
  NEW_PRODUCT: null,
  ISSUE_2_NEW_SALE: null,
  CONTACT_2_NEW_SALE: null,
  JIRA_CUSTOMER_2_NEW_CONTACT: null,
  UPDATED_CONTACT: null,
  HUBSPOT_2_NEW_SALE: null,
  NEW_ISSUE: null,
  UPDATED_ISSUE: null,
});

export const RuleItemTypes = keyMirror({
  EVENT: null,
  ACTION: null,
  FILTER: null,
});

export const WidgetTypes = keyMirror({
  chart: null,
  grid: null,
  goal: null,
  scorecard: null,
});

export const ChartTypes = keyMirror({
  line: null,
  column: null,
  bar: null,
  pie: null,
});
